// Using react datepicker references from official docs: https://flowbite.com/docs/plugins/datepicker/#react-support
import React, { useState } from 'react';
import { DayPicker, CaptionLayout, ClassNames } from 'react-day-picker';
import './date-picker.sass';

const EVENT_DATE_STYLE = {
    padding: '10px',
    borderBottom: '2px solid rgba(0, 128, 0, 0.5)',
};

export interface DatePickerProps {
    value?: Date;
    onChange: (date: Date) => void;
    testId?: string;
    eventDates?: Date[];
    fromYear?: number;
    toYear?: number;
    captionLayout?: CaptionLayout;
}

export const DatePicker: React.FC<DatePickerProps> = (props) => {
    const { value = new Date(), onChange, testId, eventDates, fromYear, toYear, captionLayout } = props;

    const [selectedDay, setSelectedDay] = useState<Date | undefined>(value ?? new Date());

    const month = value;

    const modifiers = { eventDates };
    const modifierStyles = { eventDates: EVENT_DATE_STYLE };

    const classNames: ClassNames = {
        caption: 'custom-caption',
    };

    return (
        <div data-testid={testId}>
            <DayPicker
                mode="single"
                captionLayout={captionLayout}
                fromYear={fromYear}
                toYear={toYear}
                modifiersStyles={modifierStyles}
                selected={selectedDay}
                onSelect={setSelectedDay}
            />
        </div>
    );
};
